export default __webpack_public_path__ + "static/media/home_p1_icon.c9d28b7c.svg";